import { render, staticRenderFns } from "./attach_captain.vue?vue&type=template&id=0294277e&scoped=true&"
import script from "./attach_captain.vue?vue&type=script&lang=js&"
export * from "./attach_captain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0294277e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0294277e')) {
      api.createRecord('0294277e', component.options)
    } else {
      api.reload('0294277e', component.options)
    }
    module.hot.accept("./attach_captain.vue?vue&type=template&id=0294277e&scoped=true&", function () {
      api.rerender('0294277e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers/actions/attach_captain.vue"
export default component.exports